import type { FC } from 'react';
import {
  Box,
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableFooter,
  TablePagination,
  TableCell,
} from '@material-ui/core';
import Title from 'src/components/admin/Title';
import Scrollbar from 'src/components/admin/Scrollbar';
import TableCellHeaderBasic from 'src/components/global/TableCellHeaderBasic';
import { numberToMillons } from 'src/utils/functions';

interface PropsSeguimientoOficinaConvenio {
  content: {
    data: any;
    resume: { operaciones: number; facturacion: number; meta: number };
    pages: { total: number; current: number; limit: number };
  };
  handleChangePage: (event: unknown, page: number) => Promise<void>;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => Promise<void>;
}

const SeguimientoOficinaConvenio: FC<PropsSeguimientoOficinaConvenio> = ({
  content,
  handleChangePage,
  handleChangeRowsPerPage,
}) => {
  const title = 'Facturación por Convenios, En unidades, MM de PEN';
  const headers = [
    { label: 'Convenio', width: '*' },
    { label: 'Operaciones', width: '150px' },
    { label: 'Facturación', width: '150px' },
  ];

  return (
    <>
      <Box pt={2}>
        <Title title={title} />
        <Card>
          <Scrollbar>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {headers.map((header, index) => (
                    <TableCellHeaderBasic
                      key={header.label}
                      align={index !== 0 ? 'right' : 'left'}
                      width={header.width}
                    >
                      {header.label}
                    </TableCellHeaderBasic>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {content.data.map((item, index) => {
                  const key = `row-detail-convenio-${index}`;
                  return (
                    <TableRow key={key}>
                      <TableCell>
                        { item.label }
                      </TableCell>
                      <TableCell align="right">
                        { item.operaciones }
                      </TableCell>
                      <TableCell align="right">
                        { numberToMillons(item.facturacion) }
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
              <TableHead>
                <TableRow>
                  <TableCellHeaderBasic>Total</TableCellHeaderBasic>
                  <TableCellHeaderBasic align="right">
                    {content.resume.operaciones}
                  </TableCellHeaderBasic>
                  <TableCellHeaderBasic align="right">
                    {numberToMillons(content.resume.facturacion)}
                  </TableCellHeaderBasic>
                </TableRow>
              </TableHead>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    backIconButtonProps={{
                      title: 'Página anterior',
                    }}
                    nextIconButtonProps={{
                      title: 'Página siguiente',
                    }}
                    rowsPerPageOptions={[5, 10, 15, 20]}
                    labelRowsPerPage="Registros por página"
                    labelDisplayedRows={({ from, to, count }) => `${from} al ${to} de ${count}`}
                    count={content.pages.total}
                    page={content.pages.current}
                    rowsPerPage={content.pages.limit}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </Scrollbar>
        </Card>
      </Box>
    </>
  );
};

export default SeguimientoOficinaConvenio;
